import { DataObject, DataObjectFactory } from "@/v2/models/base-data-object.js";
import { Parameter } from "@/v2/models/parameters.js";

export class ProductCategory extends DataObject {
    _type = "product_category";

    id;
    parent_id;
    image_id;
    name;
    full_name;
    parent_name;
    slug;
    product_count;
    children;
    created_at;
    updated_at;
    deleted_at;
    bo_can_delete;
    show_action_menu;
}

export class ProductCategoryMapperParameter extends Parameter {
    productCategoryMapper;
}

export class ProductCategoryFactory {
    /**
     * Creates a new instance of a DataObject.
     * @function
     * @static
     * @param {Object, null} data Data to construct the ProductCategory object with. Also creates a product object using MetaFactory if data is not null.
     * @returns {ProductCategory}
     */
    static construct(productCategoryMapperParameter, data = null) {
        if (data != null) {
            let productCategory = DataObjectFactory.getInstance().constructWithMapper(
                ProductCategory,
                productCategoryMapperParameter.productCategoryMapper,
                data
            );

            if (data.children != null) {
                let children = [];
                data.children.forEach((childrenData) => {
                    const child = DataObjectFactory.getInstance().constructWithMapper(
                        ProductCategory,
                        productCategoryMapperParameter.productCategoryMapper,
                        childrenData
                    );
                    children.push(child);
                });

                productCategory.children = children;
            }

            return productCategory;
        }

        return null;
    }
}
